import { MutationTree } from 'vuex'

import FamilyMember from '@/lib/class/FamilyMember'
import { FamilyState } from '@/store/family/types'

export default <MutationTree<FamilyState>>{
  saveFamilyMembers(state, familyMembers: FamilyMember[]) {
    state.familyMembers = familyMembers
  },

  updateFamilyMember(
    state,
    {
      familyMember,
      username,
    }: { familyMember: FamilyMember; username: string },
  ) {
    const familyMemberToUpdate = state.familyMembers.find(
      ({ username: un }) => un === username,
    )

    if (!familyMemberToUpdate) {
      throw new Error(
        `Could not find family member with username '${username}' in store`,
      )
    }

    Object.assign(familyMemberToUpdate, familyMember)
  },

  setHasAttemptedToLoadData(state, newAttemptValue: boolean) {
    state.hasAttemptedToLoadData = newAttemptValue
  },
}
